import { AxiosResponse } from 'axios';

import { Axios } from '../AxiosApiServerWrapper';

export const RedcliffeService = {
  GetRedcliffeLocalities: async (payload: { query: string }): Promise<AxiosResponse> => {
    const url = `vendors/redcliffe/locality`;
    return Axios.Request({ methodType: 'GET', url, params: payload });
  },
  GetRedcliffeSlots: async (payload: {
    id: string;
    invoiceId: string;
    eloc: string;
    collectionDate: string;
    slotPeriod: number;
  }): Promise<AxiosResponse> => {
    const url = `fx/lab/slots`;
    return Axios.Request({ methodType: 'GET', url, params: payload });
  },
  GetDirectRedcliffeSlots: async (payload: {
    eloc: string;
    collectionDate: string;
    slotPeriod: number;
  }): Promise<AxiosResponse> => {
    const url = `vendors/redcliffe/slots`;
    return Axios.Request({ methodType: 'GET', url, params: payload });
  },
  CreateRedcliffeFulfillment: async (payload): Promise<AxiosResponse> => {
    const url = `fx/lab`;
    return Axios.Request({ methodType: 'POST', url, payload });
  },
  GetLabPreparation: async (payload: { invoiceId: string }): Promise<AxiosResponse> => {
    const url = `fx/lab/invoices/${payload.invoiceId}/preparation`;
    return Axios.Request({ methodType: 'GET', url });
  },
};
